import { SyncSupplierItemRequest } from "./SyncSupplierItemsRequest";

export default class UpsertSupplierRequest {
  constructor(
    public tenantId: number,
    public code: string,
    public name: string,
    public email: string,
    public customerCode: string,
    public companyName: string | undefined,
    public address: string | undefined,
    public contactName: string | undefined,
    public phone: string | undefined,
    public cultureName: string | undefined,
    public autoConfirmOrder: boolean,
    public autoOrderEnabled: boolean,
    public supplierItems: SyncSupplierItemRequest[]
  ) {
  }
}
